<div *ngIf="athletes && athletes.length > 0 && isLoading === false ">
  <h2>{{ title }}</h2>

  <ng-container>
    <ngx-slick-carousel [config]="slideConfig" #slickModal="slick-carousel" *ngIf="isLoading === false;else loading">
      <div ngxSlickItem *ngFor="let athlete of athletes">
        <div class="pfp-ranking">
          <div class="pfp-ranking__item">
            <a class="pfp-ranking__item__img" [href]="'/athlete/'+athlete?.Id.toString()">
              <img style="margin-bottom:0" class="athlete__photo" [src]="'//extranet.worldarchery.sport/ProfilePictures/?Id=' + athlete.Id" />
            </a>
            <div class="pfp-ranking__item__name">
              <lib-athlete-name [fname]="athlete.FName" [gname]="athlete.GName" [wnameord]="athlete.WNameOrd" [id]="athlete.Id"></lib-athlete-name>
               <a [href]="'/athlete/'+athlete?.Id.toString()"><lib-country-flag [id]="athlete.NOC"></lib-country-flag></a>
            </div>
             <!-- <div class="pfp-ranking__points">{{ruleShowPercent(athlete.Points, athlete.Cat)|async}} <span>10s</span></div>-->
          </div>
        </div>
      </div>
    </ngx-slick-carousel>

    <ng-template #loading>
      <div class="loading-throbber"></div>
    </ng-template>
  </ng-container>
</div>
